import { GetterTree } from 'vuex'

import { RootState, MonitorState } from '@/types/store'

export const getters: GetterTree<MonitorState, RootState> = {
  monitor(state): MonitorState['monitor'] {
    return state.monitor
  },
  monitors(state): MonitorState['monitors'] {
    return state.monitors
  },
  total(state): MonitorState['total'] {
    return state.total
  },
  isMonitorsLoading(state): MonitorState['isMonitorsLoading'] {
    return state.isMonitorsLoading
  },
}
